import { Component, OnInit, Input, Output, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { FormGroup, FormArray, FormControl, Validators } from '@angular/forms';

function isValidMonthDay(value: string): boolean {
    return value !== '' && !value.match(/[^\d]/g) && parseInt(value, 10) <= 31;
}

@Component({
  selector: 'app-month-day-input',
  templateUrl: './month-day-input.component.html',
  styleUrls: ['./month-day-input.component.scss']
})
export class MonthDayInputComponent implements OnInit {
  @Input() control: FormControl;
  @Output() inputChange = new EventEmitter<void>();

  public inputs: {value: string, valid: boolean}[];
  public value: string;
  public valid: boolean;
  public lastRemoved: string;

  constructor() { }

  ngOnInit() {
    const startValue = this.control && this.control.value ? this.control.value.toString() : '1';
    this.inputs = startValue.split(',').map(value => ({
      value,
      valid: isValidMonthDay(value)
    }));
    const isValid = this.inputs.every(input => input.valid);
    this.valid = isValid;
    if (this.control) {
      this.control.setErrors(isValid ? null : { required: true });
    }
  }

  onChange(inputIndex: number, event: Event) {
    if (event && event.target instanceof HTMLInputElement) {
      const value = event.target.value;
      this.inputs[inputIndex].value = value;
      this.inputs[inputIndex].valid = isValidMonthDay(value);
    }
    // Update value for parent
    const list = this.inputs.filter(input => input.valid);
    // Filter unique non-empty results
    let hasChanged = false;
    const inputResult = [...new Set(list.filter(element => element && element.value).map(element => element.value))].join(',');
    if (this.value !== inputResult) {
      this.value = inputResult;
      hasChanged = true;
      if (this.control) {
        this.control.setValue(inputResult);
        this.control.markAsDirty();
      }
    }
    // Update validity for parent
    const isValid = this.inputs.every(input => input.valid);
    if (this.valid !== isValid) {
      this.valid = isValid;
      hasChanged = true;
      if (this.control) {
        this.control.setErrors(isValid ? null : { required: true });
      }
    }
    if (hasChanged) {
      this.inputChange.emit();
    }
  }

  onRemoveClick(inputIndex: number) {
    if (inputIndex === 0 && this.inputs.length <= 1) {
      console.log('Skipped removal');
      return;
    }
    this.lastRemoved = this.inputs[inputIndex].valid ? this.inputs[inputIndex].value : '';
    this.inputs.splice(inputIndex, 1);
    this.onChange(null, null);
  }

  focusEmptyInput(selectEmpty = false) {
    const inputs: HTMLInputElement[] = Array.prototype.map.call(document.querySelectorAll('app-month-day-input input'), e => e);
    for (const input of inputs) {
      if (input.value === '') {
        input.focus();
        window.setTimeout(() => input.focus(), 100);
        return;
      }
    }
  }

  onAddClick() {
    if (this.inputs.some(input => input.value === '')) {
      // There is at least a single empty input so focus it
      window.setTimeout(this.focusEmptyInput.bind(this), 100);
      return;
    }
    this.inputs.push({
      value: this.lastRemoved || '',
      valid: true
    });
    this.lastRemoved = '';
    window.setTimeout(this.focusEmptyInput.bind(this), 100);
  }

}
